import { Component, OnInit, Output, EventEmitter, ViewChild, TemplateRef, Input, HostBinding, ChangeDetectorRef, Optional, Inject, LOCALE_ID } from '@angular/core';
import { TypeConverter } from '@farris/ide-property-panel';
import { UrgeHandleRule } from './urge-handle-rule';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import {ExpressionService, InjectedType} from '@gsp-svc/expression';
import { MessagerService } from '@farris/ui-messager';
import { SmsMessageTemplate } from '../sms-message-template/sms-message-template';
import { SmsMessageTemplateComponent } from '../sms-message-template/sms-message-template.component';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';

@Component({
  selector: 'lib-urge-handle-rule',
  templateUrl: './urge-handle-rule.component.html',
  styleUrls: ['./urge-handle-rule.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class UrgeHandleRuleComponent implements OnInit {

  groupIcon2 = '<i class="f-icon f-icon-lookup"></i>';
  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();

  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  @ViewChild(SmsMessageTemplateComponent) SmsTemplate:SmsMessageTemplateComponent

  @Input()
  set value(data: any) {
    if (!data) {
      this.urgeHandleRule.urgeHandleAble = true;
      this.urgeHandleRule.earlyTime = 0;
      this.urgeHandleRule.intervalTime = 0;
      this.urgeHandleRule.sendType = 'cloudplus,inmail';
      this.urgeHandleRule.urgeMessageSubject = `{\"expr\":\"'${this.localePipe.transform("component.urgeHandleRule.urgentApproval")}' + DefaultFunction.GetContextParameter(\\\"bizDefName\\\")\",\"sexpr\":\"\"}`;
      this.urgeHandleRule.urgeMessageContent = `{\"expr\":\"'${this.localePipe.transform("component.urgeHandleRule.pleaseApprove")}' + DefaultFunction.GetContextParameter(\\\"procInstCreatorName\\\") + '${this.localePipe.transform("component.urgeHandleRule.soOn")}' + DefaultFunction.GetContextParameter(\\\"bizDefName\\\") + '。'\",\"sexpr\":\"\"}`;
    } else {
      this.urgeHandleRule = data;
      if (this.hasSmsMessage(this.urgeHandleRule.sendType)) {
        this.hasSmsTemplate = true;
        if (!this.urgeHandleRule.smsMessageTemplate) {
          this.urgeHandleRule.smsMessageTemplate = new SmsMessageTemplate();
        }
      }
    }
  }

  urgeHandleRule: UrgeHandleRule = new UrgeHandleRule();


  typeGroup = this.designerUIState.messageChannels.map(m => ({ value: m.code, name: m.name }));

  modalConfig = {
    title: this.localePipe.transform("component.urgeHandleRule.urgeHandle"),
    width: 800,
    height: 515,
    showButtons: true
  };

  hasSmsTemplate = false;

  constructor(
    private designerUIState: ProcessDesignerUIState,
    private expr: ExpressionService,
    private message: MessagerService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe) {
      this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
    }
  ngOnInit() {
  }

  clickOK() {
    if (this.SmsTemplate) {
      this.SmsTemplate.endGridEdit();
    }
    if (this.hasSmsTemplate) {
      this.urgeHandleRule.smsMessageTemplate = this.SmsTemplate.smsMessageTemplate;
      if (this.urgeHandleRule.smsMessageTemplate.smsMessageVariables && this.urgeHandleRule.smsMessageTemplate.smsMessageVariables.length > 0) {
        this.urgeHandleRule.smsMessageTemplate.smsMessageVariables = this.urgeHandleRule.smsMessageTemplate.smsMessageVariables.filter(variable => variable.code);
      }
    } else {
      this.urgeHandleRule.smsMessageTemplate = null;
    }
    if (this.validator()) {
      const object = { value: this.urgeHandleRule, parameters: null };
      this.submitModal.emit(object);
    }
  }

  clickCancel() {
    this.closeModal.emit();
  }

  private validator() {
    if (!this.urgeHandleRule.sendType) {
      this.message.info(this.localePipe.transform("component.urgeHandleRule.noSendingMethod"));
      return false;
    }
    //去除消息模板编号校验
    // if (this.hasSmsTemplate) {
    //   if (!this.urgeHandleRule.smsMessageTemplate) {
    //     this.message.info(this.localePipe.transform("component.urgeHandleRule.setMessageTemplate"));
    //     return;
    //   }
    //   if (!this.urgeHandleRule.smsMessageTemplate.code) {
    //     this.message.info(this.localePipe.transform("component.urgeHandleRule.codeEmpty"));
    //     return;
    //   }
    // }
    if (!this.urgeHandleRule.urgeMessageSubject) {
      this.message.info(this.localePipe.transform("component.urgeHandleRule.noMessageSubject"));
      return false;
    }
    if (!this.urgeHandleRule.urgeMessageContent) {
      this.message.info(this.localePipe.transform("component.urgeHandleRule.noMessageContent"));
      return false;
    }
    if (!this.urgeHandleRule.earlyTime && this.urgeHandleRule.earlyTime!==0 ) {
      this.message.info(this.localePipe.transform("component.urgeHandleRule.earliestTimeNotEmpty"));
      return false;
    }
    if (!this.urgeHandleRule.intervalTime && this.urgeHandleRule.intervalTime!==0 ) {
      this.message.info(this.localePipe.transform("component.urgeHandleRule.minimumTimeNotEmpty"));
      return false;
    }
    return true;
  }

  sendTypeChange(sendType: string) {
    if (this.hasSmsMessage(sendType)) {
      this.hasSmsTemplate = true;
      if (!this.urgeHandleRule.smsMessageTemplate) {
        this.urgeHandleRule.smsMessageTemplate = new SmsMessageTemplate();
      }
    } else {
      this.hasSmsTemplate = false;
      this.urgeHandleRule.smsMessageTemplate = null;
    }
  }

  parser = (val: string | number) => {
    return Number(val);
  }

  titleExpr(data: any){
    this.showTitleHelp(data);
  }

  contentExpr(data: any){
    this.showContentHelp(data);
  }

  showTitleHelp(data: string) {
    const context = this.showExpr();
    if (this.urgeHandleRule.urgeMessageSubject && this.urgeHandleRule.urgeMessageSubject.length > 0) {
      this.expr.addExpressionText(this.urgeHandleRule.urgeMessageSubject);
    } else {
      this.expr.addExpressionText('');
    }
    this.expr.buildExpression().then((expressionInfo: string) => {
      this.urgeHandleRule.urgeMessageSubject = expressionInfo;
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }

  showContentHelp(data: string){
    const context = this.showExpr();
    if (this.urgeHandleRule.urgeMessageContent && this.urgeHandleRule.urgeMessageContent.length > 0) {
      this.expr.addExpressionText(this.urgeHandleRule.urgeMessageContent);
    } else {
      this.expr.addExpressionText('');
    }
    this.expr.buildExpression().then((expressionInfo: string) => {
      this.urgeHandleRule.urgeMessageContent = expressionInfo;
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }

  showExpr(){
    // this.expr.clearContext();
    if (this.designerUIState.schemas.length > 0) {
      for (const schema of this.designerUIState.schemas) {
        // this.expr.addCommonObject(co);
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerUIState.schemas[0].entityTypes && this.designerUIState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerUIState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    const context = new Array();
    if (this.designerUIState.urgeContext.length > 0) {
      for (const variable of this.designerUIState.urgeContext) {
        context.push(variable);
        // this.expr.addContext(variable);
      }
    }
    if (this.designerUIState.processVariableContext.length > 0) {
      for (const variable of this.designerUIState.processVariableContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
        // this.expr.addContext(variable);
      }
    }
    if (this.designerUIState.subActivityContext.length > 0) {
      for (const variable of this.designerUIState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
        // this.expr.addContext(variable);
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    return context;
  }

  private hasSmsMessage(sendType: string) {
    if (sendType) {
      const sendTypeList = sendType.split(',');
      let messageChannel = sendTypeList.find(val => this.designerUIState.messageChannels.find(channel => channel.code == val && channel.channelType == 'Sms'));
      if (messageChannel) {
        return true;
      } else {
        return false;
      }
    } else {
      return false
    }
  }

}

export class UrgeHandleRuleConverter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data: any): string {
    if (!data) {
      return this.localePipe.transform("component.urgeHandleRule.set");
    } else if (data.urgeHandleAble) {
      return this.localePipe.transform("component.urgeHandleRule.set");
    } else {
      return this.localePipe.transform("component.urgeHandleRule.notSet");
    }
  }
}
